export function bbGenerateShortId(prefix?: string) {
	prefix = prefix || '';
	return prefix + Math.random().toString(36).substr(2, 16);
}
